import { useQuery } from "@tanstack/react-query";
import { getDiagnosis, getDiagnosisByUserId } from "../api/diagnosis.api";
import { DiagnosisRow } from "../api/diagnosis.type";
import { useUserDetails } from "./useUserDetails";

function useLoadDiagnoses(userId?: string) {
  const { userDetails } = useUserDetails();

  const {
    data: diagnoses = [],
    isLoading,
    error,
  } = useQuery<DiagnosisRow[]>({
    queryKey: ["diagnoses", userId || userDetails?.id],
    queryFn: () =>
      userId ? getDiagnosisByUserId(userId) : getDiagnosis(userDetails?.id),
    select: (data) => (Array.isArray(data) ? data : []),
    enabled: Boolean(userId || userDetails?.id),
  });

  return { diagnoses, isLoading, error };
}

export default useLoadDiagnoses;
